import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBSeparator } from '@shared/components/list';
import { Colors } from '@shared/styles';

export function MBChatReadMarker() {
  return (
    <View row center padding={1}>
      <View flex>
        <MBSeparator color={Colors.v2.red} />
      </View>
      <View paddingHorizontal={1}>
        <Text size="body2" color={Colors.v2.red}>
          new messages
        </Text>
      </View>
      <View flex>
        <MBSeparator color={Colors.v2.red} />
      </View>
    </View>
  );
}
